module.exports = __webpack_public_path__ + "static/media/list.847b0d6f.svg";